import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SnackService } from '../../../services/snack.service';
import { environment } from '../../../../environments/environment';
import { User } from '../../../model/user';

@Component({
  selector: 'app-auth-redirect-component',
  template: '',
})
export class AuthRedirectComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private httpClient: HttpClient,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    const searchParams = this.extractAuthSearchParams();

    this.callExternalAuth(searchParams)
      .then(({ accessToken, user }) => {
        this.authService.setAuthenticatedStateFromToken(accessToken, user);

        const inpressURI = sessionStorage.getItem('inpressURI');

        console.log('inpressURI', inpressURI);

        if (inpressURI && this.isValidInternalRedirect(inpressURI)) {
          console.log('isValidInternalRedirect');
          const { pathname, search } = new URL(inpressURI);
          this.router.navigateByUrl(`${pathname}${search}`);
          return;
        }

        if (inpressURI && this.isValidClientCorner2Redirect(inpressURI)) {
          console.log('isValidClientCorner2Redirect');
          document.location.href = inpressURI;
          return;
        }

        console.log('isDashboardRedirect');
        document.location.href = environment.veDashboardUrl;
      })
      .catch((err) => {
        console.error('Failed to call external auth', err);
        this.snackService.showError('Ongeldige loginpoging');
      });
  }

  private async callExternalAuth({
    authorizationCode,
    state,
  }: {
    authorizationCode: string;
    state: string;
  }) {
    return this.httpClient
      .post<{ accessToken: string; user: User }>('/api/external-auth', {
        authorization_code: authorizationCode,
        client_id: environment.veClientId,
        state,
      })
      .toPromise();
  }

  private extractAuthSearchParams() {
    const currentUrl = new URL(document.location.href);

    const authorizationCode = currentUrl.searchParams.get('code') ?? '';
    const state = currentUrl.searchParams.get('state') ?? '';

    const isValidState = this.authService.verifySessionState(state);

    if (!isValidState) {
      console.error('Invalid auth state');
      this.authService.logout();
      this.snackService.showError('Ongeldige loginpoging');
      this.router.navigateByUrl('/login');

      throw new Error('Invalid state');
    }

    return {
      authorizationCode,
      state,
    };
  }

  private isValidInternalRedirect(uri: string): boolean {
    try {
      const url = new URL(uri);
      const currentOrigin = new URL(document.location.href).origin;

      // Only allow same-origin redirects
      return (
        url.origin === currentOrigin &&
        !url.pathname.startsWith('/client-corner-2')
      );
    } catch {
      return false;
    }
  }

  private isValidClientCorner2Redirect(uri: string): boolean {
    try {
      const url = new URL(uri);
      const currentOrigin = new URL(document.location.href).origin;

      // Only allow same-origin redirects
      return (
        url.origin === currentOrigin &&
        url.pathname.startsWith('/client-corner-2')
      );
    } catch {
      return false;
    }
  }
}
